// images
import blogImg1 from "../images/blog/img-1.jpg";
import blogImg2 from "../images/blog/img-2.jpg";
import blogImg3 from "../images/blog/img-3.jpg";



const blogs = [
    {
        id: '1',
        title: 'How can you Generate Perfect AI Photo.',
        screens: blogImg1,
        description: 'Consectetur adipiscing elit. Purusout phasellus malesuada lectus.',
        author: 'Marilou Kelleher',
        authorTitle:'Sineor Consultant',
        create_at: '25 Dec, 2023',
        comment:'35',
        blClass:'format-standard-image',
    },
    {
        id: '2',
        title: 'How to Build Successful Business Startup.',
        screens: blogImg2,
        description: 'Consectetur adipiscing elit. Purusout phasellus malesuada lectus.',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: '13 Dec,2023',
        comment:'80',
        blClass:'format-standard-image',
    },
    {
        id: '3',
        title: 'The standard chunk of used since the interested.',
        screens: blogImg3,
        description: 'Consectetur adipiscing elit. Purusout phasellus malesuada lectus.',
        author: 'Aliza Anny',
        authorTitle:'Art Director',
        create_at: '22 Dec,2023',
        comment:'95',
        blClass:'format-video',
    },
    {
        id: '2',
        title: 'Have evolved over the years sometimes accident.',
        screens: blogImg2,
        description: 'Consectetur adipiscing elit. Purusout phasellus malesuada lectus.',
        author: 'Konal Biry',
        authorTitle:'Creative Director',
        create_at: '13 Dec,2023',
        comment:'80',
        blClass:'format-standard-image',
    },
];
export default blogs;